const CLIENT_SIDE_AUTH_STATE = Symbol("client-side-auth-state");

export default CLIENT_SIDE_AUTH_STATE;
